import { render, staticRenderFns } from "./PatientEdit.vue?vue&type=template&id=10aea7d0"
import script from "./PatientEdit.vue?vue&type=script&lang=js"
export * from "./PatientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports